import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BnInternalHeaders, ENV_CONFIG, MarketingProductId, SimpleResponse } from '@bn/primitives';
import { UserDetails, UserMarketingDetailsMode } from '@bn/shared/core/api';

@Injectable({
  providedIn: 'root',
})
export class UserDetailsApiService {
  readonly #ENV_CONFIG = inject(ENV_CONFIG);
  readonly #httpClient = inject(HttpClient);
  readonly #apiUrl!: string;

  public constructor() {
    this.#apiUrl = `${this.#ENV_CONFIG.apiUrl}/user`;
  }

  public getFreshUserDetails(): Observable<UserDetails> {
    return this.#httpClient.get<UserDetails>(this.#apiUrl);

    // // Note: Only for testing purposes!
    // const lsUserDetails = localStorage.getItem('#userDetails');

    // return this.#httpClient.get<UserDetails>(this.#apiUrl).pipe(
    //   switchMap((userDetails: UserDetails) => {
    //     if (lsUserDetails)
    //       return of({
    //         ...userDetails,
    //         ...JSON.parse(lsUserDetails),
    //       } as UserDetails);

    //     return of(userDetails);
    //   }),
    // );
  }

  public updateUserDetails(userDetails: Partial<UserDetails>): Observable<UserDetails | undefined> {
    return this.#httpClient.post<UserDetails | undefined>(`${this.#apiUrl}`, userDetails, {
      headers: { [BnInternalHeaders.IgnoreErrorToast]: 'true' },
    });
  }

  public getMarketingDetails(): Observable<UserMarketingDetailsMode> {
    return this.#httpClient.get<UserMarketingDetailsMode>(`${this.#apiUrl}/mkd`);
  }

  public setMarketingAddPageEnter(productId: MarketingProductId): Observable<void> {
    return this.#httpClient.put<void>(`${this.#apiUrl}/marketing/property/${productId}`, {});
  }

  public resendConfirmationEmail(): Observable<null> {
    return this.#httpClient.post<null>(`${this.#apiUrl}/resend-email-confirmation`, {});
  }

  public disableTwoFactorAuthentication(Password: string): Observable<SimpleResponse> {
    return this.#httpClient.post<SimpleResponse>(`${this.#apiUrl}/2fa/disable`, { Password });
  }

  public extendFreeTrial(): Observable<null> {
    return this.#httpClient.post<null>(
      `${this.#apiUrl}/extend-free-trial`,
      {},
      {
        headers: { [BnInternalHeaders.IgnoreErrorToast]: 'true' },
      },
    );
  }

  public extendFreeTrialAllUsers(): Observable<null> {
    return this.#httpClient.post<null>(
      `${this.#apiUrl}/extend-expired-free-trial`,
      {},
      {
        headers: { [BnInternalHeaders.IgnoreErrorToast]: 'true' },
      },
    );
  }
}
